export const ON_MILANOTE_MARK_DIRTY = 'onMilanoteMarkDirty';
export const ON_MILANOTE_MARK_DIRTY_AND_FLUSH = 'onMilanoteMarkDirtyAndFlush';
